import script from "./ScheduleModalLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleModalLoader.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleModalLoader.vue?vue&type=style&index=0&id=8a5f4634&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a5f4634"]])

export default __exports__